export interface ItemGroupSalesMonthPoint {
  month: string;
  quantity: number;
  amount: number;
  profit_amount?: number | null;
  profit_is_partial?: boolean;
}

export interface ItemGroupSale {
  item_group: string;
  quantity: number;
  amount: number;
  profit_amount?: number | null;
  profit_is_partial?: boolean;
  missing_cost_items?: string[];
  monthly?: ItemGroupSalesMonthPoint[];
}

export interface SelectedItemSalesMonth {
  month: string;
  quantity: number;
  amount: number;
  profit_amount: number | null;
  profit_is_partial: boolean;
}

export function aggregateSelectedItemSales(
  data: ItemGroupSale[],
  selectedGroups: Set<string>,
): { monthly: SelectedItemSalesMonth[]; hasProfitData: boolean; missingCostItems: string[] } {
  const selected = data.filter((group) => selectedGroups.has(group.item_group));
  const months = Array.from(new Set(data.flatMap((group) => (group.monthly ?? []).map((point) => point.month)))).sort();
  const monthly = months.map((month) => {
    let quantity = 0;
    let amount = 0;
    let profit = 0;
    let hasProfit = false;
    let profitIsPartial = false;
    for (const group of selected) {
      const point = (group.monthly ?? []).find((entry) => entry.month === month);
      if (!point) continue;
      quantity += point.quantity ?? 0;
      amount += point.amount ?? 0;
      if (point.profit_amount != null) {
        profit += point.profit_amount;
        hasProfit = true;
      } else if ((point.amount ?? 0) > 0) {
        profitIsPartial = true;
      }
      profitIsPartial = profitIsPartial || Boolean(point.profit_is_partial);
    }
    return {
      month,
      quantity,
      amount,
      profit_amount: hasProfit ? profit : null,
      profit_is_partial: profitIsPartial,
    };
  });

  return {
    monthly,
    hasProfitData: selected.some((group) => group.profit_amount != null),
    missingCostItems: Array.from(new Set(selected.flatMap((group) => group.missing_cost_items ?? []))).sort(),
  };
}
